// Section head (RESTYLE §1): the mono eyebrow "BEHAVIOR ··· count" over the rule-strong hairline, and the section's
// controls right-aligned under it. No figure numbers, sentence titles, captions or source lines: the label names it.
//   <FigHead no label count? actions? className? />
//       no: the section's place on the page, for its ids only: header#fig-N (the scroll target of j / k and the number
//       keys, scroll-padding aware) and h2#fig-N-t (the label; for the section's aria-labelledby)
import type { ReactNode } from "react";
import { cx } from "./cx";

export const figId = (no: number) => `fig-${no}`;
export const figTitleId = (no: number) => `fig-${no}-t`;

export function FigHead({
  no,
  label,
  count,
  actions,
  className,
}: {
  no: number;
  label: ReactNode;
  count?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cx("fig-head", className)} id={figId(no)}>
      <div className="fig-eyebrow">
        <h2 id={figTitleId(no)}>{label}</h2>
        {count !== undefined && count !== null && count !== false && <span className="count">{count}</span>}
      </div>
      {actions && <div className="fig-actions">{actions}</div>}
    </header>
  );
}
